import { VStack } from "@chakra-ui/react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { getGroups, getGroupsKey } from "modules/groups/api/getGroups";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { ChakraText } from "components/ChakraText";
import { useReactQuery } from "components/RemoteData";
import { NavigationBarButton } from "components/LayoutComponents";

const Groups = () => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const match = useRouteMatch<{
    groupId: string;
  }>({
    path: "/e-rezerwacja/:friendlyUrl/:groupId?",
  });
  const groupId = match?.params.groupId;

  const { data: groupList } = useReactQuery(getGroupsKey(), () =>
    getGroups(friendlyUrl)
  );

  const { push } = useHistory();

  return (
    <VStack spacing="30px" mt={2} p={4}>
      {groupList?.map((group) => {
        const isActive = group.id.toString() === groupId;
        return (
          <NavigationBarButton
            isActive={isActive}
            key={group.id}
            onClick={() => {
              push(`/e-rezerwacja/${friendlyUrl}/${group.id}`);
            }}
            id={`navigation-group-btn-${group.id}`}
          >
            <ChakraText>{group.name}</ChakraText>
          </NavigationBarButton>
        );
      })}
    </VStack>
  );
};

export { Groups };
